<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div class="relative w-full max-w-4xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] flex flex-col">
    <div class="flex items-center justify-between mb-5 pb-4 border-b border-slate-100 dark:border-slate-800">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">history</span>
          Log การเข้าสู่ระบบ
        </h3>
        <p class="text-sm text-slate-500 mt-1 font-medium">
          {{ user.displayName || '—' }} · {{ user.login }}
        </p>
      </div>
      <button type="button" (click)="onClose()"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors border-none bg-transparent cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex flex-col sm:flex-row gap-3 mb-4">
      <div class="relative flex-1">
        <input type="text" [(ngModel)]="searchEventText"
          (focus)="onEventInputFocus()" (blur)="closeEventDropdown()"
          placeholder="กรองประเภทเหตุการณ์"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200" />
        <div *ngIf="openEventDropdown"
          (mousedown)="$event.preventDefault()"
          class="absolute top-full left-0 mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-slate-100 dark:border-slate-700 max-h-48 overflow-y-auto z-45 py-2 custom-scrollbar">
          <button type="button" *ngFor="let opt of filteredEventOptions" (click)="selectEventType(opt.value)"
            class="w-full text-left px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-amber-900/10 cursor-pointer border-none bg-transparent"
            [ngClass]="eventType === opt.value ? 'text-amber-500' : 'text-slate-600 dark:text-slate-300'">
            {{ opt.label }}
          </button>
        </div>
      </div>
      <button type="button" (click)="onFilter()"
        class="px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl cursor-pointer border-none">
        ค้นหา
      </button>
    </div>

    <div class="overflow-x-auto custom-scrollbar flex-1 min-h-[240px] relative rounded-2xl border border-slate-100 dark:border-slate-800">
      <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 z-10 flex items-center justify-center">
        <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
      </div>
      <table class="w-full text-left border-collapse">
        <thead class="bg-slate-50 dark:bg-slate-800/80">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-3">เวลา</th>
            <th class="p-3">เหตุการณ์</th>
            <th class="p-3">IP</th>
            <th class="p-3">รายละเอียด</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
          <tr *ngFor="let log of logs()" class="text-sm">
            <td class="p-3 text-xs text-slate-500 whitespace-nowrap">{{ log.createDate | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="p-3">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                [ngClass]="eventBadgeClass(log.eventType)">
                {{ eventLabel(log.eventType) }}
              </span>
            </td>
            <td class="p-3 font-mono text-xs text-slate-500">{{ log.ipAddress || '—' }}</td>
            <td class="p-3 text-slate-600 dark:text-slate-300">
              <p class="text-sm">{{ log.message || '—' }}</p>
              <p *ngIf="log.userAgent" class="text-[11px] text-slate-400 mt-0.5 truncate max-w-md">{{ log.userAgent }}</p>
            </td>
          </tr>
          <tr *ngIf="logs().length === 0 && !isLoading()">
            <td colspan="4" class="py-16 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">search_off</span>
              <p class="font-bold">ยังไม่มี log ของผู้ใช้นี้</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex items-center justify-between gap-3 mt-4 pt-4 border-t border-slate-100 dark:border-slate-800">
      <p class="text-xs text-slate-500 font-medium">{{ totalItems() | number }} รายการ</p>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30 cursor-pointer bg-white">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <span class="text-sm font-bold text-slate-600">{{ currentPage() }} / {{ totalPages() || 1 }}</span>
        <button type="button" (click)="setPage(currentPage() + 1)" [disabled]="currentPage() >= totalPages()"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30 cursor-pointer bg-white">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
      <button type="button" (click)="onClose()"
        class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 text-slate-500 font-bold rounded-xl cursor-pointer border-none">
        ปิด
      </button>
    </div>
  </div>
</div>
